module.exports = __webpack_public_path__ + "static/media/11_temp_poor.659613ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/11_temp_poor.png
// module id = 708
// module chunks = 0